import NbmModel from "../../models/produto/nbmModel";
import { iServiceCached } from "../base/iServiceCached";

class NbmService extends iServiceCached<NbmModel> {
    constructor() {
        super("Nbm");
    }

    public async comboCached(franquiaId: number) {
        const retorno = await this.combo(franquiaId);
        return retorno.map(p => ({
            value: p.id,
            text: p.codigo + " - " + p.descricao,
        }));
    }
}

export default new NbmService();
